import React, { Component } from 'react';

import { WIZARD_STEP_VALUES } from './common-util/resources';
import { WizardStepsMap } from './common-util/types';

interface Props {
    steps: WizardStepsMap;
    currentStep: WIZARD_STEP_VALUES;
}

class WizardNavbarView extends Component<Props> {

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    render() {
        const navigationSteps = Object.keys(this.props.steps).map((stepName: string, index: number) => {
            const step = this.props.steps[stepName as WIZARD_STEP_VALUES];
            return (
                <li key={index}>
                    <small className='wizard-step-number'>Step {index + 1}</small>
                    <br />
                    <span className={step.value === this.props.currentStep ? 'active' : ''}>{step.label}</span>
                </li>
            );
        });

        return (
            <ul className='wizard-wizard-navigation'>
                {navigationSteps}
            </ul>
        );
    }
}

export default WizardNavbarView;
